export const initialCostCentersState = {
  costCenters: [],
  loading: true,
};

export type TCostCenters = {
  id?: string,
  name?: string,
  code?: string,
  addedOn?: string,
}

export interface ICostCentersState {
  costCenters: TCostCenters[],
  loading: boolean
}
